import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { Venue } from 'src/WebApiController';

import * as styles from './EventSearchDropdownResult.css';

export const VenueSearchResultItem = ({ venue }: { venue: Venue }) => {
  const { data } = useCatalogDataContext();
  const country = venue?.ctryCode
    ? data?.countries?.[venue.ctryCode]?.name || venue.ctryCode
    : null;
  return (
    <div className={styles.eventSearchResultItemDiv}>
      <div className={styles.eventSearchResultItemNameDiv}>{venue.name}</div>
      <div className={styles.eventSearchResultItemDateDiv}>
        {`${venue.city}, ${venue.state || ''} ${country || ''}`}
      </div>
    </div>
  );
};
